var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: 0;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19277",
    "data-name": "Group 19277",
    transform: "translate(-11722.5 20305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19275",
    "data-name": "Group 19275",
    className: "cls-1",
    transform: "translate(11722.5 -20304.693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18725",
    "data-name": "Rectangle 18725",
    className: "cls-2",
    width: 25,
    height: 17,
    transform: "translate(0 -0.306)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19276",
    "data-name": "Group 19276",
    transform: "translate(11724.965 -20296.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9101",
    "data-name": "Path 9101",
    className: "cls-3",
    d: "M20.2,8.305a1.305,1.305,0,0,1,1.39-.188c.459.212.582.641.273.957a16.138,16.138,0,0,1-3.318,2.648l1.1,1.311c.277.33.112.752-.367.942a1.316,1.316,0,0,1-1.3-.185l-.064-.067-.991-1.181a12.457,12.457,0,0,1-3.9.939V14.9c0,.381-.448.69-1,.69a.942.942,0,0,1-.995-.609l-.007-.08V13.48a12.457,12.457,0,0,1-3.9-.939l-.991,1.181-.064.067a1.316,1.316,0,0,1-1.3.185c-.479-.191-.643-.612-.367-.942h0l1.1-1.311A16.138,16.138,0,0,1,2.17,9.074c-.308-.316-.186-.745.273-.957a1.305,1.305,0,0,1,1.39.188,11.24,11.24,0,0,0,8.183,3.833A11.24,11.24,0,0,0,20.2,8.305Z",
    transform: "translate(-2 -8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.be8195ca824f2039b95a363161d828cb.svg";
export { ForwardRef as ReactComponent };